"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var swr_1 = __importDefault(require("swr"));
var firebase_1 = require("../lib/firebase");
var create_container_1 = __importDefault(require("../utils/create-container"));
var useAuth = function () {
    var _a = swr_1.default('currentUser', function () {
        return new Promise(function (resolve, reject) {
            try {
                var unsubscribe_1 = firebase_1.firebase
                    .auth()
                    .onAuthStateChanged(function (user) {
                    if (user) {
                        user.getIdTokenResult().then(function (idTokenResult) {
                            /* eslint-disable no-param-reassign */
                            user.admin = idTokenResult.claims.admin;
                        });
                    }
                    unsubscribe_1();
                    resolve(user);
                });
            }
            catch (error) {
                reject(error.message);
            }
        });
    }), data = _a.data, mutate = _a.mutate;
    react_1.default.useEffect(function () {
        var unsubscribe = firebase_1.firebase.auth().onAuthStateChanged(mutate);
        return unsubscribe;
    }, [mutate]);
    return data;
};
var AuthContext = create_container_1.default(useAuth);
exports.default = AuthContext;
//# sourceMappingURL=auth.js.map